module.exports = __webpack_public_path__ + "img/Cedar & Elm V1 960x540.524f9df2.png";